/* Flowrette — autocomplete natif (Shopify Predictive Search). Remplace le panneau Boost. */
(function () {
  'use strict';
  var MINQ = 2, DEBOUNCE = 220, LIMIT = 6, LIMIT_NAV = 3;
  var timer = null, seq = 0, countCache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
  }
  function thumb(u) {
    if (!u) return '';
    u = String(u);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=140&height=140&crop=center';
  }
  function safeMark(styled, fallback) {
    var s = esc(fallback);
    if (!styled) return s;
    var clean = String(styled).replace(/<(?!\/?mark\b)[^>]*>/g, '');
    return /<mark>/.test(clean) ? clean.replace(/<(?!\/?mark>)[^>]*>/g, '') : s;
  }

  function panelFor(input) {
    var box = input.closest('.search--container');
    if (!box) return null;
    var p = box.querySelector('.fw-ac');
    if (!p) {
      p = document.createElement('div');
      p.className = 'fw-ac';
      p.hidden = true;
      box.appendChild(p);
    }
    return p;
  }

  function hideAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.fw-ac'), function (p) {
      p.hidden = true;
      p.innerHTML = '';
    });
  }

  function render(panel, q, res, count) {
    var cols = res.collections || [], prods = res.products || [], qs = res.queries || [];
    if (!cols.length && !prods.length) {
      panel.innerHTML = '<div class="fw-ac__empty">Aucun résultat pour « ' + esc(q) + ' »</div>';
      panel.hidden = false;
      return;
    }
    var left = '';
    if (cols.length || qs.length) {
      left += '<div class="fw-ac__col fw-ac__col--nav">';
      if (cols.length) {
        left += '<p class="fw-ac__head">Collections</p><ul class="fw-ac__list">';
        cols.slice(0, LIMIT_NAV).forEach(function (c) {
          left += '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        left += '</ul>';
      }
      if (qs.length) {
        left += '<p class="fw-ac__head">Suggestions</p><ul class="fw-ac__list">';
        qs.slice(0, LIMIT_NAV).forEach(function (s) {
          left += '<li><a href="' + esc(s.url) + '">' + safeMark(s.styled_text, s.text) + '</a></li>';
        });
        left += '</ul>';
      }
      left += '</div>';
    }
    var right = '<div class="fw-ac__col fw-ac__col--prod"><p class="fw-ac__head">Produits</p><div class="fw-ac__grid">';
    prods.forEach(function (p) {
      var img = thumb((p.featured_image && p.featured_image.url) || p.image);
      var promo = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
      right += '<a class="fw-ac__item" href="' + esc(p.url) + '">'
        + '<span class="fw-ac__thumb">'
        + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '')
        + (p.available ? '' : '<span class="fw-ac__badge">Épuisé</span>')
        + '</span><span class="fw-ac__meta">'
        + '<span class="fw-ac__title">' + esc(p.title) + '</span>'
        + '<span class="fw-ac__price">' + money(p.price)
        + (promo ? ' <s>' + money(p.compare_at_price_max) + '</s>' : '')
        + '</span></span></a>';
    });
    right += '</div></div>';
    var label = count == null ? 'Voir tous les produits'
      : 'Voir ' + (count > 1 ? 'tous les ' + count + ' produits' : 'le produit');
    var foot = '<a class="fw-ac__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">'
      + label + ' <span aria-hidden="true">→</span></a>';
    var colsCls = left ? 'fw-ac__cols' : 'fw-ac__cols fw-ac__cols--nonav';
    panel.innerHTML = '<div class="' + colsCls + '">' + left + right + '</div>' + foot;
    panel.hidden = false;
  }

  function fetchCount(q) {
    if (countCache[q] != null) return Promise.resolve(countCache[q]);
    var p = new URLSearchParams();
    p.set('type', 'product'); p.set('q', q); p.set('view', 'count');
    return fetch('/search?' + p.toString(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        var n = t == null ? null : parseInt(String(t).trim(), 10);
        if (!isNaN(n)) { countCache[q] = n; return n; }
        return null;
      })
      .catch(function () { return null; });
  }

  function run(input) {
    var panel = panelFor(input);
    if (!panel) return;
    var q = (input.value || '').trim();
    if (q.length < MINQ) { panel.hidden = true; panel.innerHTML = ''; return; }
    var mine = ++seq;
    var p = new URLSearchParams();
    p.set('q', q);
    p.set('resources[type]', 'product,collection,query');
    p.set('resources[limit]', String(LIMIT));
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    p.set('resources[options][unavailable_products]', 'last');
    Promise.all([
      fetch('/search/suggest.json?' + p.toString()).then(function (r) { return r.json(); }),
      fetchCount(q)
    ]).then(function (out) {
      if (mine !== seq) return;
      render(panel, q, (out[0].resources && out[0].resources.results) || {}, out[1]);
    }).catch(function () {
      if (mine === seq) { panel.hidden = true; panel.innerHTML = ''; }
    });
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('search--input')) return;
    if (t.getAttribute('search') !== 'produit') return;
    clearTimeout(timer);
    timer = setTimeout(function () { run(t); }, DEBOUNCE);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && (e.target.closest('.fw-ac') || e.target.closest('.form-search--container'))) return;
    if (e.target.closest && e.target.closest('.search--trigger')) return;
    hideAll();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideAll(); });
})();